/**
 * @module free-shipping-bar/config
 *
 * Static configuration for the cart-drawer Shipping Progress Bar.
 */

// Currency symbols for the manual formatting fallback (when Intl is unavailable).
export const CURRENCY_SYMBOLS: Record<string, string> = {
  USD: '$',
  CAD: 'CA$',
  GBP: '£',
  EUR: '€',
  AUD: 'A$',
  NZD: 'NZ$',
  HKD: 'HK$',
  KRW: '₩',
  SGD: 'S$',
  INR: '₹',
  MYR: 'RM',
  THB: '฿',
};

// Zero-decimal currencies (no cents).
export const ZERO_DECIMAL_CURRENCIES: string[] = ['KRW', 'JPY', 'VND', 'CLP', 'TWD'];

export type VendorFreeShippingRule = {
  vendor: string;
  markets?: string[];
  allCountries?: boolean;
};

/**
 * Vendor free-shipping rules — mirror the `df-vendor-free-shipping` Shopify
 * Function so the drawer message agrees with the discount actually applied.
 *
 * A cart qualifies when it contains at least one line item from `vendor`
 * (exact, case-sensitive, trimmed match) AND the shopper's market country is
 * in `markets` (or `allCountries` is true). Free shipping is granted
 * regardless of cart spend.
 *
 * IMPORTANT: this list is a static mirror of the vendor free-shipping
 * discount nodes configured in the Shopify admin — it has no activation
 * window of its own. An entry MUST be added when its discount node goes
 * live and removed when the node ends or is deactivated, or the drawer
 * will promise free shipping that checkout no longer grants.
 *
 * Currently empty: no vendor free-shipping promo is active. The Chemistry
 * Brand entry (June 2026 promo, story 42072) was removed after its discount
 * node expired on June 15 2026 — the stale mirror kept showing "You qualify
 * for free shipping" while checkout charged shipping (defect 43621).
 */

// TODO: 43661 to update this approach (url: https://dev.azure.com/10em/Digital%20Transformation/_workitems/edit/43661/)
export const VENDOR_FREE_SHIPPING: VendorFreeShippingRule[] = [];
